module.exports = __webpack_public_path__ + "static/node-6a97bce81e672319baafc813e40ec0ff.jpeg";